import { schema } from 'normalizr';
import labelSchema from './label';

const trainingPlanCourse = new schema.Entity('learningCourses', {
  targetLabels: [labelSchema],
  optionalTargetLabels: [labelSchema],
});

export default trainingPlanCourse;
